<script lang="ts">
    import { format } from "date-fns";

    /** The plan's chosen start date; null when the plan starts today. */
    export let startDate: Date | null
</script>

<!-- Sits in the second column of the setup forms' label/input grid, directly under the Start Date input. -->
{#if startDate}
    <p class="col-start-2 -mt-6 mb-0 text-left text-sm text-slate-500">
        <i class="fa-regular fa-hourglass-half mr-1"/>
        Your forecasted plan will use today's fitness as its starting point. Until {format(startDate, 'MMMM do')}, you'll be on a XATA maintenance plan.
    </p>
{/if}
